import ProveedorUpdate from './ProveedorUpdate'
export {ProveedorUpdate}
export default ProveedorUpdate
